import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'alexander_buerkle',
} as IModuleProps;
